import HasACar from '@/icons/requirements/HasACar.vue';
import ComfortableWithPets from '@/icons/requirements/ComfortableWithPets.vue';
import SpecialNeedsExperience from '@/icons/requirements/SpecialNeedsExperience.vue';
import MultiplesExperience from '@/icons/requirements/MultiplesExperience.vue';
import { Requirements } from '@/store/modules/job/types';

export interface RequirementOption {
  value: Requirements;
  textLabel: string;
  icon: typeof HasACar | typeof ComfortableWithPets | typeof SpecialNeedsExperience | typeof MultiplesExperience;
}

export const requirementOptions: RequirementOption[] = [
  {
    value: Requirements.HAS_A_CAR,
    icon: HasACar,
    textLabel: 'Sitter has own car',
  },
  {
    value: Requirements.COMFORTABLE_WITH_PETS,
    icon: ComfortableWithPets,
    textLabel: 'Comfortable with pets',
  },
  {
    value: Requirements.SPECIAL_NEEDS_EXPERIENCE,
    icon: SpecialNeedsExperience,
    textLabel: 'Special needs experience',
  },
  {
    value: Requirements.MULTIPLES_EXPERIENCE,
    icon: MultiplesExperience,
    textLabel: 'Multiples experience',
  },
];
